import { useMemo, useState } from 'react';

/** Manage a per-row selection set. Pass the current visible page of items and
 * their id extractor; get back the boolean state and toggles used by the
 * table checkboxes + BulkActionBar. */
export function useSelection(items, getId = (it) => it.id) {
  const [selected, setSelected] = useState(() => new Set());
  const ids = useMemo(() => items.map(getId), [items, getId]);
  const allSelected = ids.length > 0 && ids.every((id) => selected.has(id));
  const someSelected = selected.size > 0 && !allSelected;

  const toggle = (id) => setSelected((prev) => {
    const next = new Set(prev);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    return next;
  });

  const toggleAll = () => setSelected((prev) => {
    const next = new Set(prev);
    if (allSelected) ids.forEach((id) => next.delete(id));
    else ids.forEach((id) => next.add(id));
    return next;
  });

  const clear = () => setSelected(new Set());

  return {
    selected: Array.from(selected),
    size: selected.size,
    has: (id) => selected.has(id),
    allSelected,
    someSelected,
    toggle,
    toggleAll,
    clear,
  };
}
